<div class="block-loading">
  <div class="backdrop-loading--content"></div>
  <img [style]="{ height: '60px', zIndex: 99 }" alt="" src="../../../../assets/images/loading.gif" />
</div>
